import { AssetLibEntryAudio } from "./AssetLibEntryAudio";
import { AssetLibEntryHelp } from "./AssetLibEntryHelp";
import { AssetLibEntryImage } from "./AssetLibEntryImage";
import { AssetLibEntryUrl } from "./AssetLibEntryUrl";
import { AssetLibEntryVideo } from "./AssetLibEntryVideo";

export function AssetLibEntry(props: { data : any, tab : any }) {
  if (props.data.type === "image") {
    return (<AssetLibEntryImage data={props.data} tab={props.tab} />);
  } else if (props.data.type === "audio") {
    return (<AssetLibEntryAudio data={props.data} tab={props.tab} />);
  } else if (props.data.type === "video") {
    return (<AssetLibEntryVideo data={props.data} />);
  } else if (props.data.type === "help") {
    return (<AssetLibEntryHelp data={props.data} />);
  } else if (props.data.type === "url") {
    return (<AssetLibEntryUrl data={props.data} />);
  }

  return null;
}
